export default [
    {
        path:'wx-auth',
        component(resolve) {
            require(['@/components/student/login/wx-auth'], resolve)
        },
        meta: {  
            isAuth : false,
            title : '登录'
        }
    },
    {
        path:'wx-check',
        component(resolve) {
            require(['@/components/student/login/wx-check'], resolve)
        },
        meta: {  
            title : '课程状态'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/student/login.js